//src/services/adminReviews.api.js
import { adminApiRequest } from "./adminApi";

export const getReviewRequestQueue = () => {
  return adminApiRequest("/admin/reviews/request-queue");
};

export const getReviewRequests = () => {
  return adminApiRequest("/admin/reviews/requests");
};

export const sendReviewRequests = ({ orderItemIds, language }) => {
  return adminApiRequest("/admin/reviews/send-requests", {
    method: "POST",
    body: JSON.stringify({
      orderItemIds,
      language,
    }),
  });
};

export const deleteReviewRequest = (id) => {
  return adminApiRequest(`/admin/reviews/requests/${id}`, {
    method: "DELETE",
  });
};

export const getReviewConversation = (id) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/conversation`);
};

export const sendAdminReviewReply = ({ id, body }) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/reply`, {
    method: "POST",
    body: JSON.stringify({ body }),
  });
};

export const simulateCustomerReviewReply = ({ id, body }) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/simulate-customer-reply`, {
    method: "POST",
    body: JSON.stringify({ body }),
  });
};

export const simulateCustomerRatingReply = ({ id, body }) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/simulate-rating-reply`, {
    method: "POST",
    body: JSON.stringify({ body }),
  });
};

export const getProductReviews = () => {
  return adminApiRequest("/admin/reviews/product-reviews");
};

export const updateProductReviewStatus = ({ id, status }) => {
  return adminApiRequest(`/admin/reviews/product-reviews/${id}/status`, {
    method: "PUT",
    body: JSON.stringify({ status }),
  });
};

export const getReviewManualResolveOptions = () => {
  return adminApiRequest("/admin/reviews/manual-resolve-options");
};

export const resolveReviewManually = ({
  id,
  selectedReviewMessageId = null,
  selectedRatingMessageId = null,
  selectedMediaMessageIds = [],
  manualRating = null,
  manualReviewText = "",
  reviewPreset = "",
}) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/manual-resolve`, {
    method: "POST",
    body: JSON.stringify({
      selectedReviewMessageId,
      selectedRatingMessageId,
      selectedMediaMessageIds,
      manualRating,
      manualReviewText,
      reviewPreset,
    }),
  });
};

export const runReviewAutoRating = () => {
  return adminApiRequest("/admin/reviews/run-auto-rating", {
    method: "POST",
  });
};

export const resendReviewRequest = (id) => {
  return adminApiRequest(`/admin/reviews/requests/${id}/resend`, {
    method: "POST",
  });
};
